"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parseMask;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _constants = require("../constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function parseMask(_ref) {
  var formatChars = _ref.formatChars,
      mask = _ref.mask,
      maskPlaceholder = _ref.maskPlaceholder;
  var permanents = [];

  var combinedFormatChars = _objectSpread(_objectSpread({}, _constants.defaultFormatChars), formatChars);

  if (!mask) {
    return {
      maskPlaceholder: '',
      mask: '',
      prefix: '',
      lastEditablePosition: 0,
      permanents: []
    };
  }

  if (typeof mask === 'string') {
    var isPermanent = false;
    var parsedMaskString = '';
    mask.split('').forEach(function (character) {
      if (!isPermanent && character === '\\') {
        isPermanent = true;
      } else {
        if (isPermanent || !combinedFormatChars[character] && !combinedFormatChars[character.toLowerCase()]) {
          permanents.push(parsedMaskString.length);
        }

        parsedMaskString += character;
        isPermanent = false;
      }
    });
    mask = parsedMaskString.split('').map(function (character, index) {
      if (permanents.indexOf(index) === -1) {
        return combinedFormatChars[character];
      }

      return character;
    });
  } else {
    mask.forEach(function (character, index) {
      if (typeof character === 'string') {
        permanents.push(index);
      }
    });
  }

  if (maskPlaceholder) {
    var maskPlaceholderBuilder;

    if (maskPlaceholder.length === 1) {
      maskPlaceholderBuilder = mask.map(function (character, index) {
        if (permanents.indexOf(index) !== -1) {
          return character;
        }

        return maskPlaceholder;
      });
    } else {
      maskPlaceholderBuilder = maskPlaceholder.split('');
    }

    if (mask && maskPlaceholderBuilder) {
      permanents.forEach(function (position) {
        if (mask[position]) {
          maskPlaceholderBuilder[position] = mask[position];
        }
      });
      maskPlaceholder = maskPlaceholderBuilder.join('');
    }
  }

  var prefix = permanents.filter(function (position, index) {
    return position === index;
  }).map(function (position) {
    return mask && mask[position] ? mask[position] : '';
  }).join('');
  var lastEditablePosition = mask.length - 1;

  while (permanents.indexOf(lastEditablePosition) !== -1) {
    lastEditablePosition--;
  }

  return {
    maskPlaceholder: maskPlaceholder,
    prefix: prefix,
    mask: mask,
    lastEditablePosition: lastEditablePosition,
    permanents: permanents
  };
}